// src/api.js
import axios from "axios";

// const API_BASE_URL = "https://briefgarden.com/api/v1/";
const API_BASE_URL = "https://briefgarden.com/api/v1/";

const api = axios.create({
  baseURL: API_BASE_URL,
  // headers: { "Content-Type": "application/json" }, // REMOVE THIS!
});

// Add request interceptor to include token
api.interceptors.request.use(
  (config) => {
    if(localStorage.getItem("token")){
    const token = localStorage.getItem("token");
    config.headers["Authorization"] = `Bearer ${token}`
    }else{
      const token = localStorage.getItem("user_token");
      config.headers["Authorization"] = `Bearer ${token}`
    }
    
   
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getData = async (endpoint) => {
  try {
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const postData = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data, {
      headers: { "Content-Type": "application/json" }, // set only for JSON
    });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const putData = async (endpoint, data) => {
  try {
    const response = await api.put(endpoint, data, {
      headers: { "Content-Type": "application/json" }, // set only for JSON
    });
    return response.data;
  } catch (error) {
    console.error("Error putting data:", error);
    throw error;
  }
};

export const uploadFile = async (endpoint, formData) => {
  // Do NOT set Content-Type here; let browser/axios handle it for FormData!
  const response = await api.post(endpoint, formData);
  return response.data;
};
